<template>
  <div class="history-page">
    <div class="history-header">
      <div><h1>我的匹配任务</h1><p>继续支付、下载结果，或查看历史处理记录</p></div>
      <el-button type="primary" @click="$router.push('/bookMatch')">新建匹配</el-button>
    </div>

    <el-card shadow="never" class="history-card">
      <div class="filters">
        <el-select v-model="query.status" clearable placeholder="全部状态" @change="search">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-input v-model.trim="query.fileName" clearable placeholder="搜索文件名" @keyup.enter.native="load" />
        <el-button @click="search">查询</el-button>
      </div>

      <el-table v-loading="loading" :data="rows" class="pc-table" @row-click="openTask">
        <el-table-column prop="originalFileName" label="文件" min-width="220" show-overflow-tooltip />
        <el-table-column label="状态" width="120">
          <template slot-scope="scope"><el-tag :type="tagType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="totalRows" label="数据行" width="100" />
        <el-table-column prop="matchedUniqueCount" label="成功唯一数" width="120" />
        <el-table-column label="金额" width="100"><template slot-scope="scope">{{ money(scope.row.payableAmountFen) }}</template></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" />
        <el-table-column label="操作" width="100"><template slot-scope="scope"><el-button type="text" @click.stop="openTask(scope.row)">{{ actionText(scope.row) }}</el-button></template></el-table-column>
      </el-table>

      <div class="mobile-list">
        <div v-for="row in rows" :key="row.id" class="mobile-task" @click="openTask(row)">
          <div class="task-top"><strong>{{ row.originalFileName }}</strong><el-tag size="mini" :type="tagType(row.status)">{{ statusText(row.status) }}</el-tag></div>
          <div class="task-stats"><span>总行数 {{ format(row.totalRows) }}</span><span>成功 {{ format(row.matchedUniqueCount) }}</span><span>{{ money(row.payableAmountFen) }}</span></div>
          <div class="task-time">{{ row.createTime }}</div>
        </div>
      </div>

      <el-empty v-if="!loading && !rows.length" description="还没有匹配任务" />
      <el-pagination
        v-if="total"
        background
        layout="prev, pager, next"
        :current-page="query.current"
        :page-size="query.size"
        :total="total"
        @current-change="changePage"
      />
    </el-card>
  </div>
</template>

<script>
import { getBookMatchPage } from '@/api/bookMatch'

export default {
  name: 'MyBookMatch',
  data () {
    return {
      loading: false,
      rows: [],
      total: 0,
      query: { current: 1, size: 10, status: '', fileName: '' },
      statusOptions: [
        { value: 'READY_TO_PAY', label: '待支付' },
        { value: 'PAID_READY', label: '可下载' },
        { value: 'FREE_READY', label: '免费可下载' },
        { value: 'FAILED', label: '处理失败' },
        { value: 'EXPIRED', label: '已过期' }
      ]
    }
  },
  created () { this.load() },
  methods: {
    async load () {
      this.loading = true
      try {
        const response = await getBookMatchPage(this.query)
        this.rows = response.data.records || []
        this.total = Number(response.data.total) || 0
      } finally {
        this.loading = false
      }
    },
    search () { this.query.current = 1; this.load() },
    changePage (page) { this.query.current = page; this.load() },
    openTask (row) { this.$router.push('/bookMatch/task/' + row.id) },
    statusText (status) {
      return { DRAFT: '待重新上传', QUEUED: '排队中', PARSING: '读取中', MATCHING: '匹配中', GENERATING: '生成中', READY_TO_PAY: '待支付', PAID_READY: '可下载', FREE_READY: '免费可下载', FAILED: '失败', CANCELLED: '已取消', EXPIRED: '已过期' }[status] || status
    },
    tagType (status) {
      if (status === 'PAID_READY' || status === 'FREE_READY') return 'success'
      if (status === 'READY_TO_PAY') return 'warning'
      if (status === 'FAILED') return 'danger'
      if (status === 'EXPIRED' || status === 'CANCELLED') return 'info'
      return ''
    },
    actionText (row) {
      if (row.canDownload) return '下载'
      if (row.canPay) return '去支付'
      if (row.canRetry) return '重试'
      return '查看'
    },
    format (value) { return (Number(value) || 0).toLocaleString('zh-CN') },
    money (fen) { return '¥' + ((Number(fen) || 0) / 100).toFixed(2) }
  }
}
</script>

<style lang="less" scoped>
.history-page { padding: 28px; }
.history-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 22px; }
.history-header h1 { margin: 0 0 7px; font-size: 26px; }
.history-header p { margin: 0; color: #6b7280; }
.history-card { border: 0; }
.filters { display: flex; gap: 10px; margin-bottom: 18px; }
.filters .el-input { width: 240px; }
.pc-table /deep/ tbody tr { cursor: pointer; }
.el-pagination { margin-top: 20px; text-align: right; }
.mobile-list { display: none; }
@media screen and (max-width: 768px) {
  .history-page { padding: 16px 12px; }
  .history-header { align-items: flex-start; }
  .history-header h1 { font-size: 22px; }
  .history-header p { display: none; }
  .filters { display: grid; grid-template-columns: 1fr auto; }
  .filters .el-input { width: 100%; }
  .filters .el-select { grid-column: 1 / 3; width: 100%; }
  .pc-table { display: none; }
  .mobile-list { display: block; }
  .mobile-task { padding: 15px 0; border-bottom: 1px solid #edf0f3; }
  .task-top { display: flex; justify-content: space-between; gap: 10px; }
  .task-top strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .task-stats { display: flex; justify-content: space-between; margin-top: 12px; color: #4b5563; font-size: 13px; }
  .task-time { margin-top: 9px; color: #9ca3af; font-size: 12px; }
  .el-pagination { text-align: center; }
}
</style>
